import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormStage } from '../dynamic-form/dynamic-form/dynamic-form.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-stage-progress',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './stage-progress.component.html',
  styleUrls: ['./stage-progress.component.scss']
})
export class StageProgressComponent {
  @Input() stages: FormStage[] = [];
  @Input() currentStageIndex: number = 0;
  @Input() compact: boolean = false;

  getStageStatus(index: number): string {
    if (index < this.currentStageIndex) return 'completed';
    if (index === this.currentStageIndex) return 'current';
    return 'pending';
  }

  getProgressPercentage(): number {
    if (this.stages.length === 0) return 0;
    return (this.currentStageIndex / this.stages.length) * 100;
  }
}